export class ImportScheduleActionsNames {
    static ChangeDialogHeight = (): string => '[ImportSchedule] ChangeDialogHeight';
    static ChangeDialogHeightSuccess = (): string => '[ImportSchedule] ChangeDialogHeight Success';

    static BrowseClick = (): string => '[ImportSchedule] BrowseClick';
    static BrowseClickSuccess = (): string => '[ImportSchedule] BrowseClick Success';

    static ImportScheduleClick = (): string => '[ImportSchedule] ImportScheduleClick';
    static ImportScheduleClickSuccess = (): string => '[ImportSchedule] ImportScheduleClick Success';
}